"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REQUIRED_STRING = Symbol('Required string');
exports.REQUIRED_NUMBER = Symbol('Required number');
exports.REQUIRED_BOOLEAN = Symbol('Required boolean');
exports.REQUIRED_STRING_ARRAY = Symbol('Required string array');
exports.REQUIRED_NUMBER_ARRAY = Symbol('Required number array');
exports.REQUIRED_BOOLEAN_ARRAY = Symbol('Required boolean array');
exports.OPTIONAL_STRING = Symbol('Optional string');
exports.OPTIONAL_NUMBER = Symbol('Optional number');
exports.OPTIONAL_BOOLEAN = Symbol('Optional boolean');
exports.OPTIONAL_STRING_ARRAY = Symbol('Optional string array');
exports.OPTIONAL_NUMBER_ARRAY = Symbol('Optional number array');
exports.OPTIONAL_BOOLEAN_ARRAY = Symbol('Optional boolean array');
exports.REQUIRED = [
    exports.REQUIRED_STRING,
    exports.REQUIRED_NUMBER,
    exports.REQUIRED_BOOLEAN,
    exports.REQUIRED_STRING_ARRAY,
    exports.REQUIRED_NUMBER_ARRAY,
    exports.REQUIRED_BOOLEAN_ARRAY,
];
//# sourceMappingURL=symbols.js.map